import type { Lang } from "./types";
import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import pt from "./locales/pt";
import it from "./locales/it";
import de from "./locales/de";
import ar from "./locales/ar";

const supported: Lang[] = ["en", "es", "fr", "pt", "it", "de", "ar"];

export const supportedLangs = supported;
export const LANG_STORAGE_KEY = "freecrm-lang";

export function detectLang(): Lang {
  if (typeof window !== "undefined") {
    try {
      const saved = window.localStorage.getItem(LANG_STORAGE_KEY) as Lang | null;
      if (saved && supported.includes(saved)) return saved;
    } catch {
      /* ignore */
    }
  }
  if (typeof navigator === "undefined") return "en";
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]) || [];
  for (const l of langs) {
    const code = l.toLowerCase().split("-")[0] as Lang;
    if (supported.includes(code)) return code;
  }
  return "en";
}

export function setLang(lang: Lang) {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  window.location.reload();
}


export const bundles = { en, es, fr, pt, it, de, ar } as const;

export function useLocale() {
  return bundles[detectLang()];
}
